import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { remove_flash, hide_messages } from "lib/helpers"

// content/index — data-controller="content--index"
export default class extends Controller {
  static targets = ["table"]

  static values = {
    currentApp: Number,
    deleteBlobPath: String,
    rootBlobPath: String,
    usersEditPath: String,
    reader: Boolean,
  }

  connect() {
    if (!this.hasTableTarget) return

    $.fn.dataTable.ext.errMode = function (_settings, _helpPage, message) {
      alert("Internal server error")
      console.error(message)
    }

    this.currentFilter = `blobs_filter${this.currentAppValue}`
    this.#initFilter()
    this.#initDataTable()
    this.#loadAutocompleteSource()
    this.element.addEventListener("change", this.boundCheckboxChanged)
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundCheckboxChanged)
    this.#destroyAutocomplete()

    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }

    window.oTable = null
  }

  showPhoto(event) {
    event.preventDefault()
    $("#image-preview").attr("src", event.currentTarget.dataset.url)
    $("#image-modal").modal("show")
  }

  removeSelected(event) {
    event.preventDefault()

    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const availableCheckboxes = $(`input[name^='${groupName}']`)
    const allCheckboxes = checkboxes.length === availableCheckboxes.length

    if (!availableCheckboxes.length) return

    if (!checkboxes.length) {
      alert("Please select at least one item")
      return
    }

    if (!confirm("Are you sure? All selected items will be removed")) return

    $(".dataTables_processing").css("display", "block")
    remove_flash()
    hide_messages()

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.delete(
      this.deleteBlobPathValue,
      { item_ids: ids },
      (response) => {
        this.#showRemoveResult(response)
        this.#redrawAfterRemove(allCheckboxes)
      },
    )

    $("#check-all").prop("checked", false)
  }

  boundCheckboxChanged = (event) => {
    if (event.target.matches("#check-all")) {
      const isChecked = $(event.target).prop("checked")
      $(".table-checkbox-content")
        .prop("checked", isChecked)
        .closest("tr")
        .toggleClass("selected-row", isChecked)
      return
    }

    if (event.target.matches(".table-checkbox-content")) {
      const isChecked = $(event.target).prop("checked")
      $(event.target).closest("tr").toggleClass("selected-row", isChecked)

      const selectedCount = $(".table-checkbox-content:checked").length
      const totalCount = $(".table-checkbox-content").length
      $("#check-all").prop("checked", selectedCount > 0 && selectedCount === totalCount)
    }
  }

  #initFilter() {
    const $filter = $("#blobs_filter")
    if (!$filter.length) return

    if (!$.cookie(this.currentFilter)) {
      $.cookie(this.currentFilter, "app")
    } else {
      $filter.attr("checked", $.cookie(this.currentFilter) === "app")
    }

    $filter.on("change.contentIndex", () => {
      const newFilter = $filter.is(":checked") ? "app" : "account"
      $.cookie(this.currentFilter, newFilter)
      this.dataTable.draw(true)
    })
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: '<"H"lfr>t<"F"ip<"toolbar">>',
      pagingType: "full_numbers",
      order: [1, "asc"],
      stateSave: true,
      serverSide: true,
      processing: true,
      scrollX: true,
      language: {
        searchPlaceholder: "ID, User id, Name",
      },
      ajax: {
        url: this.rootBlobPathValue,
        data: (data) => {
          data.filter = this.#currentFilterValue()
        },
      },
      stateLoadParams(_settings, data) {
        data.search.search = ""
      },
      initComplete: (settings) => {
        $("#loading").hide()
        if (!this.readerValue) {
          $("div.toolbar").html(
            '<br/><br/><a href="#" class="remove" data-action="click->content--index#removeSelected">Remove selected</a>',
          )
        }
        $(this.element).show()
        new $.fn.dataTable.Api(settings).columns.adjust().draw()
      },
      drawCallback() {
        $("#check-all").prop("checked", false)
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-content" id="check--content${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--content${cellData}"><label/>`,
            )
          },
        },
        {
          targets: 1,
          name: "id",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="${this.rootBlobPathValue}/edit/${cellData}">${cellData}</a>`,
            )
          },
        },
        {
          targets: 2,
          name: "User id",
          createdCell: (cell, cellData) => {
            $(cell).html(
              `<a href="${this.usersEditPathValue}/edit/${cellData}"><strong>${cellData}</strong></a>`,
            )
          },
        },
        {
          targets: 5,
          name: "Status",
          createdCell(cell, cellData) {
            $(cell).html(cellData !== "complete" ? "Not uploaded" : "Uploaded")
          },
        },
        {
          targets: 6,
          name: "Public",
          createdCell(cell, cellData) {
            $(cell).html(cellData === true ? "Public" : "Private")
          },
        },
        {
          targets: 8,
          createdCell: (cell, cellData, row) => {
            const data = cellData.split(" ")
            let output = ""

            if (row[4].substring(13, 19) === "image/" && row[5] === "complete") {
              output =
                `<a class="view-photo" id="photo${data[0]}" href="#" data-action="click->content--index#showPhoto" data-url="${data[1]}"><span>View</span></a>`
            } else if (row[5] === "complete") {
              output =
                `<a class="download" id="download${data[0]}" title="Open in new tab" href="${data[1]}"><span id="span${data[0]}">Download</span></a>`
            }
            $(cell).html(output)
          },
        },
        {
          targets: [0, 8],
          sortable: false,
        },
      ],
    })

    window.oTable = this.dataTable
  }

  #loadAutocompleteSource() {
    $.ajax({
      url: `${this.rootBlobPathValue}/blob_data_search`,
      type: "post",
      success: (data) => {
        const $search = $("#blobs_list_filter input")
        $search.autocomplete({ source: data.arr })
        $search.on("autocompleteselect.contentIndex", (_event, ui) => {
          this.dataTable.search(ui.item.value.replace("...", "")).draw()
        })
      },
    })
  }

  #showRemoveResult(response) {
    if (response.length > 0) {
      $("#file-upload .content").empty()
      response.forEach((message) => {
        $("#file-upload .content").append(`<p>${message}</p>`)
      })
      $("#uploading-result").hide()
      $("#file-upload").fadeIn()
    } else {
      $("#file-upload .content").empty()
      $("#file-upload").fadeOut()
      $("#uploading-result .content").html("Selected files have been successfully removed.")
      $("#uploading-result").fadeIn()
    }

    $.scrollTo(".form-results-success")
    $("body, html").animate({ scrollTop: 0 }, 800)
  }

  #redrawAfterRemove(allCheckboxes) {
    const settings = this.dataTable.settings()[0]

    if (
      allCheckboxes &&
      settings._iRecordsDisplay - settings._iDisplayStart <= settings._iDisplayLength
    ) {
      this.dataTable.page("previous").draw(false)
    } else {
      this.dataTable.draw(false)
    }
  }

  #currentFilterValue() {
    return $.cookie(this.currentFilter) || "app"
  }

  #destroyAutocomplete() {
    const $search = $("#blobs_list_filter input")
    if ($search.hasClass("ui-autocomplete-input")) {
      $search.autocomplete("destroy")
    }
    $search.off(".contentIndex")
    $("#blobs_filter").off(".contentIndex")
  }
}
